module.exports = __webpack_public_path__ + "static/Question-a7486985dabbecd4cb6f75158fbf0122.png";